export function d(item, ...optionalParam) {
  console.log(item, ...optionalParam);
}

export function e(item, ...optionalParam) {
  console.error(item, ...optionalParam);
}
